import { sidebarConstants } from '../constants/sidebar.constants';

const initialState = { 
    selected_organization: sidebarConstants.DEFAULT_MODES[3], // notification_list
    selected_tab: sidebarConstants.DEFAULT_MODES[3] // notification_list
};

export function sidebar(state = initialState, action) {
  switch (action.type) {
    case sidebarConstants.SET_ORGANIZATION: {
      return {
        ...state,
        selected_organization: action.payload
      };
    }

    case sidebarConstants.SET_TAB: {
      return {
        ...state,
        selected_tab: action.payload
      };
    }

  default:
    return state
  }
}
